import { IOveralTime } from './skills';
import { IOtherField } from '../../interfaces/other-field.interface';

export interface IOccupationExperience {
  _id?: string;
  note?: string;
  overal_time?: IOveralTime;
  position?: IOtherField;
  position_category?: IOtherField;
  section?: string;
  vessel_type?: string;
}

export class OccupationExperience implements IOccupationExperience {
  _id?: string;
  note: string;
  overal_time: IOveralTime;
  position: IOtherField;
  position_category: IOtherField;
  section: string;
  sectionName: string;
  vessel_type: string;

  constructor( experience: IOccupationExperience = {} ) {
    this._id = experience._id;
    this.note = experience.note;
    this.overal_time = experience.overal_time || {};
    this.position = experience.position || { value: undefined };
    this.position_category = experience.position_category || {};
    this.section = experience.section;
    this.vessel_type = experience.vessel_type;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/occupation-experience.ts